import { postData } from 'api/services/mediaPlanning/utils';
import {
  ApiResponse,
  CalculatedOneReach,
  OneReachBody,
} from 'api/services/mediaPlanning/types';
import { CAMPAIGN } from 'api/services/mediaPlanning/mediaPlanning';

export const getCalculatedOneReach = async (oneReachBody: OneReachBody) => {
  return postData<ApiResponse<CalculatedOneReach>>(
    `/${CAMPAIGN}/calculate-one-reach`,
    oneReachBody
  );
};
